var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"FeedbackSummary"},[_c('div',{staticClass:"header"},[_c('h1',[_vm._v(_vm._s(_vm.feedbackTitle))]),_c('p',{staticClass:"summaryDescription"},[_vm._v(_vm._s(_vm.feedbackDescription))])]),_vm._l((_vm.freeTextData),function(ref,index){
var questions = ref.questions;
var groupTitle = ref.groupTitle;
var description = ref.description;
var color = ref.color;
return _c('FreeTextQuestionGroup',{key:index,attrs:{"title":groupTitle,"description":description,"color":color}},_vm._l((questions),function(ref,index){
var question = ref.question;
var description = ref.description;
var suggestedAnswer = ref.suggestedAnswer;
var userAnswer = ref.userAnswer;
var suggestedAnswerTitle = ref.suggestedAnswerTitle;
var userAnswerTitle = ref.userAnswerTitle;
return _c('FreeTextQuestion',{key:index,attrs:{"question":question,"description":description,"suggestedAnswer":suggestedAnswer,"userAnswer":userAnswer,"color":color,"showFeedback":true,"userAnswerTitle":userAnswerTitle,"suggestedAnswerTitle":suggestedAnswerTitle}})}),1)})],2)}
var staticRenderFns = []

export { render, staticRenderFns }